import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "trial-findings",
  courseId: "for-agency-admins",
  order: 8,
  title: "Trial findings",
  subtitle: "And the officer survey",
  summary:
    "In the last week of an evaluation your officers are asked to complete a short required survey, and you receive a findings report that turns the trial into numbers and quotes.",
  learn: [
    "Know when officers see the survey and what it asks",
    "Understand how responses feed the findings report",
    "Prepare the department for the end of the evaluation",
  ],
  minutes: 3,
  releasedAt: "2026-09-14T00:00:00.000Z",
  gate: "admin",
  body: [
    {
      type: "paragraph",
      text: "The survey is thirteen tap-to-answer steps shown inside the app during the final seven days of an agency evaluation, and on the paywall for sixty days after it ends. It is required: there is no close button, and every question except the closing quote must be answered. While the trial is still running, an officer can choose \"I'm still evaluating\" to defer it for five days.",
    },
    {
      type: "bullets",
      items: [
        "One live response per officer per round. Extending the trial does not re-prompt anyone.",
        "Paid departments can be surveyed on request. Ask your account contact to open a survey window.",
        "Quotes are attributed by name in the findings report.",
        "Solo subscribers and paid agencies never see the trial survey. Only departments on an evaluation do.",
      ],
    },
    { type: "heading", text: "The findings report" },
    {
      type: "paragraph",
      text: "Your account contact generates a findings page from the evaluation: reports written, estimated time saved per officer, top users, how officers used dictation and enhancement, a cost projection, and a \"What officers said\" section built from the survey. It is shareable with command staff and the city.",
    },
    { type: "heading", text: "Before the evaluation ends" },
    {
      type: "steps",
      items: [
        "Two weeks before the end date on the \"Evaluation Period\" banner, tell officers the survey is coming and that it is short.",
        "Ask supervisors to finish any open reports in the app.",
        "When the findings link arrives, review it with your account contact.",
      ],
    },
    {
      type: "paragraph",
      text: "Finishing open reports first means the numbers reflect real use. In the findings, the cost inputs are editable, so you can model your own seat count.",
    },
    {
      type: "paragraph",
      text: "Agency dashboard lesson shows where the Evaluation Period banner appears, and Billing covers what happens after the trial.",
    },
  ],
  related: ["the-agency-dashboard", "account-and-billing"],
};

export default lesson;
